import AnchorLink from './AnchorLink';
export * from './AnchorLink';
export default AnchorLink;
